import request from '@/utils/request'

export function chargeAccountList(obj) {
  return request({
      url: '/api/finance/account/page',
      method: 'post',
      data: obj
  })
}

export function addChargeAccount(obj) {
  return request({
    url: '/api/finance/account',
    method: 'post',
    data: obj
  })
}

export function updateChargeAccount(obj) {
  return request({
    url: '/api/finance/account',
    method: 'put',
    data: obj
  })
}

export function deleteChargeAccount(id) {
  return request({
    url: `/api/finance/account/${id}`,
    method: 'delete',
  })
}
